import "./Menu.scss";
import NavMenu from "components/NavMenu/NavMenu";
import Button from "components/Button/Button";
import { useAppDispatch } from "store";
import { useCallback } from "react";
import { exchangeActions } from "../../store/reducers/exchange";

function Menu({ setOpen }: { setOpen: (value: boolean) => void }) {
  const dispatch = useAppDispatch();
  const openSignIn = useCallback(() => {
    dispatch(exchangeActions.setComponentsName("SignIn"));
  }, [dispatch]);

  return (
    <div className="menu-overlay">
      <NavMenu
        callback={() => {
          setOpen(false);
        }}
      />
      <Button
        btnName="Sign in"
        className="sign-in-btn"
        onClick={() => {
          openSignIn();
          setOpen(false);
        }}
      />
    </div>
  );
}

export default Menu;
